export default __webpack_public_path__ + "static/media/sp_1.5ce4537c.svg";